import React, { Component } from 'react'
import axios from 'axios'
import { getProperSuccessClass } from 'services/getProperSuccessClass'
import { endpoints } from '../../config/endpoints'
import WrongEmailSent from 'components/newsletters/wrongEmailSent'

class ConfirmationButton extends Component {

  constructor(props) {
    super(props)
    this.state = { resend_status: null }

    this.confirmationMessage = props.confirmationText ||
      "Willkommen zurück. Leider fehlt uns noch die Bestätigung Deiner E-Mail-Adresse. Bitte schau dazu in Deinem Postfach nach einer E-Mail von Finanztip oder lass Dir den Bestätigungslink erneut zusenden."
  }

  handleOnClick() {
    let that = this
    that.setState({ resend_status: "loading" })

    axios.post(endpoints.resend_email_url)
      .then(function (response) {
        if (response.status === 200) {
          that.setState({ resend_status: true })
        }
      })
      .catch(function (error) {
        //TODO: Add error handling
      });
  }

  buttonClasses() {
    return this.props.classes ? `${this.props.classes}` : 'light small';
  }

  render() {
    if (this.state.resend_status === "loading") {
      return (
        <div className="padding-bottom-s font-size-xxs leading-text-tight">
          Bitte warte einen Moment, wir schicken Dir derzeit den Bestätigungslink an Deine E-Mail-Adresse.
        </div>
      );
    }

    if (this.state.resend_status) {
      return (
        <div className={`padding-bottom-s font-size-xxs leading-text-tight ${getProperSuccessClass(this.props.containerName)}`} style={{ overflow: 'hidden' }}>
          <b>Vielen Dank!</b> Wir haben Dir gerade einen Link zur Bestätigung Deiner E-Mail-Adresse gesendet.
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="padding-bottom-m">
          {this.props.componentInfo}
          <span className={`font-size-xxs leading-text-tight ${this.props.textClasses}`} dangerouslySetInnerHTML={{ __html: this.confirmationMessage }} />
          {' '}<WrongEmailSent />
        </div>
        <button name="resend-button" className={this.buttonClasses()} onClick={this.handleOnClick.bind(this)}>
          Bestätigungslink zusenden
        </button>
      </React.Fragment>
    );
  }
}

export default ConfirmationButton
